import TrafficDash from "./Traffic/TrafficDash";
import GiftcardDash from "./Giftcard/GiftcardDash";
import PayrollDash from "./Payroll/PayrollDash";
import ReservationDash from "./Reservation/ReservationDash";
import Section from "./Section";

function AdminDashboard() {
  return (
    <div className="admin-dashboard">
      <Section title="Payroll">
        <PayrollDash />
      </Section>
      <Section title="Reservations">
        <ReservationDash />
      </Section>
      <Section title="Giftcards">
        <GiftcardDash />
      </Section>
      <Section title="Site Traffic">
        <TrafficDash />
      </Section>
    </div>
  );
}

export default AdminDashboard;
